import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import mode from '@/components/allMode/mode'
import aboutUS from '@/components/allMode/aboutUS'
import details from '@/components/allMode/details'


import guides from '@/components/allMode/guides'
import depositWays from '@/components/allMode/depositWays'
import gameRules from '@/components/allMode/gameRules'
import discountInfo from '@/components/allMode/discountInfo'

import gamePage from '@/components/gamePage'
import userredpacket from '@/components/userredpacket'

import agent from '@/components/agent'
import PayInfo from '@/components/PayInfo'
import register from '@/components/register'
import index from '@/components/mode/index'
import realPerson from '@/components/mode/realPerson'
import eSports from '@/components/mode/eSports'
import electronics from '@/components/mode/electronics'
import sports from '@/components/mode/sports'
import lottery from '@/components/mode/lottery'
import cards from '@/components/mode/cards'
import discount from '@/components/mode/discount'
import vip from '@/components/mode/vip'
import deposit from '@/components/mode/deposit'
import withdraw from '@/components/mode/withdraw'
import accountSetting from '@/components/mode/accountSetting'
import myWallet from '@/components/mode/myWallet'
import fundingRecords from '@/components/mode/fundingRecords'
import activityRecord from '@/components/mode/activityRecord'
import transfer from '@/components/mode/transfer'


import messages from '@/components/mode/messages'


Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/realPerson',
          name: 'realPerson',
          component: realPerson,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/eSports',
          name: 'eSports',
          component: eSports,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        },
        
        {
          path: '/electronics',
          name: 'electronics',
          component: electronics,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/sports',
          name: 'sports',
          component: sports,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/lottery',
          name: 'lottery',
          component: lottery,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/cards',
          name: 'cards',
          component: cards,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/discount',
          name: 'discount',
          component: discount,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/vip',
          name: 'vip',
          component: vip,

        }, {
          path: '/deposit',
          name: 'deposit',
          meta: {
            requireAuth: true,
          },
          component: deposit,

        }, {
          path: '/withdraw',
          name: 'withdraw',
          meta: {
            requireAuth: true,
          },
          component: withdraw,

        }, {
          path: '/accountSetting',
          name: 'accountSetting',
          meta: {
            requireAuth: true,
          },
          component: accountSetting,

        }, {
          path: '/myWallet',
          name: 'myWallet',
          meta: {
            requireAuth: true,
          },
          component: myWallet,

        }, {
          path: '/fundingRecords',
          name: 'fundingRecords',
          meta: {
            requireAuth: true,
          },
          component: fundingRecords,

        }, {
          path: '/messages',
          name: 'messages',
          // meta: {
          //   requireAuth: true,
          // },
          component: messages,

        }
        , {
          path: '/activityRecord',
          name: 'activityRecord',
          component: activityRecord,

        }, {
          path: '/transfer',
          name: 'transfer',
          component: transfer,

        }, {
          path: '/register',
          name: 'register',
          component: register,

        }
        

      ]
    }
    , {
      path: '/mode',
      name: 'mode',
      component: mode, children: [{
        path: '/aboutUS',
        name: 'aboutUS',
        component: aboutUS,
        meta: {
          keepAlive: true,//是否缓存组件
          useCatch: false//是否用缓存
        }
      },{
        path: '/guides',
        name: 'guides',
        component: guides,
      },,{
        path: '/depositWays',
        name: 'depositWays',
        component: depositWays,
      },{
        path: '/gameRules',
        name: 'gameRules',
        component: gameRules,
      },{
        path: '/discountInfo',
        name: 'discountInfo',
        component: discountInfo,
      },{
        path: '/details',
        name: 'details',
        component: details,
      },
      ]
    }
    ,
    {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,
    }, {
      path: '/userredpacket',
      name: 'userredpacket',
      component: userredpacket,
    }, 
    
    {
      path: '/agent',
      name: 'agent',
      component: agent,
    },
    {
      path: '/payInfo',
      name: 'payInfo',
      component: PayInfo,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js